import { render, staticRenderFns } from "./JobType.vue?vue&type=template&id=2ae537a6&scoped=true&"
import script from "./JobType.vue?vue&type=script&lang=js&"
export * from "./JobType.vue?vue&type=script&lang=js&"
import style0 from "./JobType.vue?vue&type=style&index=0&id=2ae537a6&prod&lang=css&"
import style1 from "./JobType.vue?vue&type=style&index=1&id=2ae537a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae537a6",
  null
  
)

export default component.exports